// GENERAL
export const API_CONFIGURABLE = "configurables/";

// USERS MANAGEMENT
export const API_PROFILE = "accounts/users/1";
export const API_USERS = "accounts/users/";
export const API_REGISTER_USER = "accounts/register-user/";
export const API_LOGIN = "token/";
export const API_RESET_PASSWORD = "password_reset/confirm/";
export const API_VERIFY_PASSWORD_RESET_TOKEN = "password_reset/validate_token/";
export const API_REQUEST_PASSWORD_RESET = "password_reset/";
export const API_ACCOUNTS_ROLES = "accounts/roles/";
export const API_ACCOUNTS_PROFILES = "accounts/profiles/";
export const API_CHANGE_PASSWORD = "accounts/users/change-password/";
export const API_FIELD_OFFICERS = "/loan-applications/field-officers/";

//LOAN APPLICATIONS
export const API_LOAN_APPLICATIONS = "loan-applications/";
export const API_LOAN_APPLICATIONS_DRAFTS = "loan-applications/drafts/";
export const API_LOAN_APPLICATIONS_RESCHEDULE =
  "loan-applications/reschedules/";
// INVENTORY MANAGEMENT
export const API_PURCHASE_ORDERS = "purchase-orders/";
export const API_PURCHASE_ORDERS_EXPORT = "purchase-orders/excel-export/";
export const API_BULK_PURCHASE_ORDERS = "purchase-orders/bulk-upload/";
export const API_BULK_PURCHASE_ORDERS_TEMPLATE =
  "order-inventories/batch-products-upload-template/";
export const API_PURCHASE_ORDER_ITEMS = "order-inventories/";
export const API_INVENTORY = "inventories/";
export const API_INVENTORY_ALL = "inventories/all/";
export const API_PRODUCTS = "products/";

// PAYROLL MANAGEMENT
export const API_PAYROLL = "payrolls/";

//LOCATION DETAILS
export const API_DISTRICTS = "all-districts/";
export const API_COUNTIES = "all-counties/";
export const API_SUB_COUNTIES = "all-sub-counties/";
export const API_PARISHES = "all-parishes/";
export const API_VILLAGES = "all-villages/";
export const API_REGIONS = "all-regions/";

export const API_DISTRICTS_PAGINATED = "districts/";
export const API_COUNTIES_PAGINATED = "counties/";
export const API_SUB_COUNTIES_PAGINATED = "sub-counties/";
export const API_PARISHES_PAGINATED = "parishes/";
export const API_VILLAGES_PAGINATED = "villages/";
export const API_REGIONS_PAGINATED = "regions/";

//CONFIGURABLES
export const API_CONFIGURABLES = "configurables/other/";
export const API_INTEREST_CONFIGURABLES =
  "configurables/interest-configurations/";
export const API_PERIOD_CONFIGURABLES =
  "configurables/loan-validity-period-configurations/";
export const API_PENALTY_CONFIGURABLES =
  "configurables/penalty-configurations/";
export const API_FEES_CONFIGURABLES =
  "configurables/fees-schedule-configurations/";
export const API_CHARTS_OF_ACCOUNTS = "accountings/charts/";
export const API_CHARTS_OF_ACCOUNTS_ALL = "accountings/charts/all/";
export const API_SUPPLIER_CONFIGURABLES = "configurables/suppliers/";
export const API_PAYMENT_MODES_CONFIGURABLES = "payments/payment-modes/";
export const API_ALLOWANCE_TYPE_CONFIGURABLES =
  "configurables/allowance-types/";
export const API_SPIRO_PLANS_CONFIGURABLES = "configurables/spiro-plans/";

//VALIDATE NIN
export const VALIDATE_NIN_API = `accounts/register-user/validate-nin/`;

// AUDIT ACTIVITY
export const API_AUDIT_ACTIVITY = "audits/activity/";

// OFFICES
export const API_DEPARTMENTS = "departments/";

// ORGANISATIONS
export const API_ORGANISATIONS = "organisations/";

// Expenses
export const API_EXPENSES = "expenses/";

// Banck Reconciliation
export const API_BANK_RECONCILIATION =
  "accountings/ledgers/reconcile-with-bank/";

// Requisitions
export const API_REQUISITIONS = "requisitions/";

// Other Income
export const API_OTHER_INCOME = "other-incomes/";
// Payments
export const API_INVOICES = "billings/invoices/";
export const API_PRNS = "payments/prns/";
export const API_MOCK_PAYMENTS = "payments/payments/mock-invoice-payment/";
export const API_BULK_INVOICE_PAYMENT =
  "payments/payments/bulk-invoice-payment/";
// REPORTS
// REPORTS
export const API_REPORTS_DASHBOARD = "reports/dashboard/";
export const API_BILLINGS_INVOICE_LIST_REPORT =
  "billings/instalments/invoice-list-report/";
export const API_LOAN_BOOK_REPORT = "reports/loan-book-report/";
export const API_ASYNC_REPORT = "reports/async-report/";
export const API_TRANSACTIONS_EXPORT = "reports/transactions-export/";
export const API_LOAN_INSTALMENT_REPORT = "reports/loan-instalment-report/";
export const API_EXPENSES_REPORT = "reports/expenses/";
export const API_OVER_PAYMENT_REPORT = "reports/over-payment-report/";

// PERMISSIONS
export const API_ACCOUNTS_PERMISSIONS = "accounts/permissions/";

// TRANSACTION LOCKS
export const API_TRANSACTION_LOCKS = "accountings/transaction-locks/";

// BILLINGS
export const API_LEDGERS = "accountings/ledgers/";
export const API_DELETED_LEDGERS = "accountings/ledgers/deleted-records/";
export const API_BILLINGS_FEES = "billings/fees/";
export const API_BILLING_INSTALMENTS = "billings/instalments/";
export const API_PAYMENTS = "payments/payments/";
export const API_DELETED_PAYMENTS = "payments/payments/deleted-records/";
export const API_PAYMENT_METHODS = "payments/payment-modes/";

// Exports
export const API_LEDGERS_EXPORT = "accountings/ledgers/excel-export/";
export const API_PRODUCTS_EXPORT = "products/excel-export/";
export const API_FINES_EXPORT = "reports/fines/";
// Reports Exports
export const API_CASH_FLOW_EXPORT = "reports/cash-flow-statement-excel/";
export const API_FINANCIAL_POSITION_EXPORT =
  "reports/financial-position-excel/";
export const API_PROFIT_AND_LOSS_EXPORT =
  "/reports/profit-and-loss-statement-excel/";
export const API_LOAN_APPLICATIONS_REPORT = "reports/loan-applications-report/";
export const API_LOAN_APPLICATIONS_REPORT_EXPORT =
  "reports/loan-applications-report/excel-export/";
export const API_LOAN_APPLICATIONS_EXPORT = "loan-applications/excel-export";
export const API_CHART_OF_ACCOUNTS_REPORT_EXPORT =
  "reports/chart-of-accounts-report-excel/";
export const API_TRIAL_BALANCE = "reports/trial-balance/";
export const API_TRIAL_BALANCE_EXPORT = "reports/trial-balance-excel/";
export const API_LOAN_BOOK_REPORT_EXPORT = "reports/loan-book-report-excel/";

// Keys the async report endpoint (API_ASYNC_REPORT) generates a report for
export const ASYNC_REPORT_LOAN_BOOK = "loan-book-report";
export const ASYNC_REPORT_LEDGERS = "ledgers";
export const ASYNC_REPORT_TRANSACTION_LIST = "transaction-list-report";
export const ASYNC_REPORT_PAYMENTS = "payments";
export const ASYNC_REPORT_EXPENSES = "expenses";
export const ASYNC_REPORT_FINES = "fines";
export const ASYNC_REPORT_INVOICE_LIST = "invoice-list-report";
export const ASYNC_REPORT_PROFIT_AND_LOSS = "profit-and-loss-statement";
export const ASYNC_REPORT_DEBTORS_AGEING = "debtors-ageing-report";
export const ASYNC_REPORT_DEBTORS_AGEING_SUMMARY =
  "debtors-ageing-report-summary";
export const ASYNC_REPORT_CHART_OF_ACCOUNTS = "chart-of-accounts-report";
export const ASYNC_REPORT_LOAN_APPLICATIONS = "loan-applications-report";
export const ASYNC_REPORT_LOAN_INSTALMENT = "loan-instalment-report";
export const ASYNC_REPORT_OVER_PAYMENT = "over-payment-report";
export const ASYNC_REPORT_IMPOUNDED_BIKES = "impounded-bikes";
export const ASYNC_REPORT_STOLEN_BIKES = "stolen-bikes";
export const ASYNC_REPORT_RELEASED_BIKES = "released-bikes";

//DASHBOARD
export const API_LOAN_GROWTH_RATE_REPORT = "reports/loan-growth-rate-report/";

//PENALTIES
export const API_LOAN_PENALTIES = "loan-applications/penalized/";
export const API_LOAN_PENALTY_CHARGES = "loan-applications/penalty-charges/";

//DISCOUNTS
export const API_LOAN_DISCOUNTS = "configurables/purchase-discount/";

// AGING REPORTS
export const AGING_REPORTS = "reports/debtors-ageing-report/";
